package com.eladfinish.bible.contest.screens.openQuestions.usecases

import com.eladfinish.bible.contest.screens.openQuestions.model.QuestionItem
import com.eladfinish.bible.contest.utils.Feed
import com.eladfinish.bible.contest.utils.SheetUtil
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive

class BuildQuestionsFromSheetUseCase {

    operator fun invoke(feed: Feed, isDebugMode: Boolean = false): List<QuestionItem> {
        val jsonElements = feed.rows
        val fieldList = SheetUtil.getFieldListFromSheet(jsonElements)
        if (fieldList.size < 2) return emptyList()

        // Note: in non-debug mode the Google Drive API returns fields in reverse order
        // (answer first, then question), matching the legacy fragment behaviour.
        var questionField = fieldList[0]
        var answerField = fieldList[1]
        if (!isDebugMode) {
            questionField = fieldList[1]
            answerField = fieldList[0]
        }

        val authorField = fieldList
            .indexOfFirst { it == "מחבר" || it == "author" }
            .takeIf { it != -1 }
            ?.let { fieldList[it] }
            .orEmpty()

        return jsonElements.mapIndexed { index, element ->
            val obj = element.jsonObject
            QuestionItem(
                question = obj.field(questionField),
                answer = obj.field(answerField),
                author = obj.field(authorField),
                num = index + 1,
            )
        }
    }

    private fun JsonObject.field(key: String): String =
        get(SheetUtil.PREFIX + key)?.jsonObject
            ?.get(SheetUtil.CONTENT)?.jsonPrimitive?.content
            .orEmpty()
}
